export const menuTitle = { title: "PRODUCT COLOUR", label: "Product Colour" }
  